import { render, staticRenderFns } from "./TipoQrWebApp.vue?vue&type=template&id=5154c018&"
import script from "./TipoQrWebApp.vue?vue&type=script&lang=js&"
export * from "./TipoQrWebApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports